import { Flex, Grid } from "src/elements";
import styled from "styled-components";
import { getPegboardHoleCount } from "../../common/pegboardHoleCounts";

const PegboardHole = styled(Flex)`
  position: relative;

  &:after {
    display: block;
    content: "";
    position: absolute;
    left: -1px;
    top: -1px;
    width: 2px;
    aspect-ratio: 1;
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

interface Props {
  pegboardWidth: number;
  pegboardHeight: number;
  holesOffsetHorizontal: number;
  holesOffsetVertical: number;
  holesGapHorizontal: number;
  holesGapVertical: number;
}

export const PegboardHoles = ({
  pegboardWidth,
  pegboardHeight,
  holesOffsetHorizontal,
  holesOffsetVertical,
  holesGapHorizontal,
  holesGapVertical,
}: Props) => {
  const holesHorizontal = getPegboardHoleCount(
    pegboardWidth,
    holesOffsetHorizontal,
    holesGapHorizontal,
  );
  const holesVertical = getPegboardHoleCount(pegboardHeight, holesOffsetVertical, holesGapVertical);

  return (
    <Grid width="100%" columns={`repeat(${holesHorizontal}, 1fr)`}>
      {Array.from(Array(holesHorizontal * holesVertical)).map((_row, i) => (
        <PegboardHole key={i} />
      ))}
    </Grid>
  );
};
